import $http from '../../../axios-instance';
import $http_fds from '../../../axios-instance-fds';
import Swal from 'sweetalert2';
import {secciones} from "../../../views/fds/utils/secciones";
import {sanitizarUrlSecciones} from "../../../views/fds/utils/utils";

/**
 * Método para obtener todos los productos fds registrados en el sistema para la emrpesa.
 *
 * @param {*} param0
 * @param {*} requestParameters contiene la información del proceso.
 */
export async function getProductosFds({commit, state}, requestParameters = {params: state.filtro_fds}) {
  commit('dashboard/load', true, {root: true});

  await $http_fds.get(`fds/productos/${state.id_empresa}`, requestParameters)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setProductosFds', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    }
  );
}

/**
 * Método para la paginacion de los productos químicos.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
 export function setPagePagination({commit, dispatch, state}, page) {
  commit('setPage', parseInt(page));
  dispatch('getProductosFds');
}

/**
 * Método para la paginacion de los productos químicos.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
export function setPerPagePagination({commit, dispatch, state}, perPage) {
  commit('setPerPage', parseInt(perPage));
  dispatch('getProductosFds');
}

/**
 * Método para obtener las versiones correspondientes a un producto fds
 * @param commit
 * @param dispatch
 * @param state
 * @param item
 */
export async function getVersionesProductoFds({commit, dispatch, state}, item) {
  commit('dashboard/load', true, {root: true});
  let id_fds_producto = item.id;
  let id_empresa = item.id_empresa;
  await $http_fds.get(`fds/producto/versiones/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setVersionesProductoFds', response.data.data);
    })
    .catch((error) => {
        commit('dashboard/load', false, {root: true});
      }
    );
}

/**
 * Método para crear versión de producto fds.
 * @param commit
 * @param dispatch
 * @param state
 * @param tipo
 * @returns {Promise<unknown>}
 */
export async function crearVersionProductoFds({commit, dispatch, state}, tipo) {
  commit('dashboard/load', true, {root: true});
  let version = {
    id_empresa: state.id_empresa,
    id_fds_producto: state.id_fds_producto,
    path: '.',
    path_te: '.',
    activo: 1,
    aprobado: 0
  };

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/version/${tipo}`, version)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        reject();
      });
  });
}

/**
 * Función para descargar el pdf de la tarjeta de emergencia
 * @param commit
 * @param state
 * @param item json Infomracion de version del producto
 * @param type string Tipo de descarga (fds|te)
 * @returns {Promise<void>}
 */
export async function descargarPdfFds({ commit, state }, item ) {
  commit('dashboard/load', true, {root: true});
  await $http_fds({
    url: `fds/producto/version/descargar/${item.id_empresa}/${item.id}/${item.type}`,
    method: "GET",
    responseType: "blob"
  }).then((response) => {
    new Blob([response], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    let name = item.path.split('/');
    link.setAttribute("download", name[name.length - 1]);
    document.body.appendChild(link);
    link.click();
    link.remove();
  })
    .catch((error) => {
      // Error al descargar pdf
    })
  commit('dashboard/load', false, {root: true});
}

/**
 * Método para editar información de versión de producto.
 * @param commit
 * @param dispatch
 * @param state
 * @param item
 * @returns {Promise<unknown>}
 */
export async function actualizarVersionProductoFds({commit, dispatch, state}, item) {
  commit('dashboard/load', true, {root: true});

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/version/${item.id}`, item)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        reject();
      });
  });
}

/**
 * Obtener secciones de lista desplegable.
 * @param commit
 * @param dispatch
 * @param state
 * @param data
 * @returns {Promise<void>}
 */
export async function getSeccion({commit, dispatch, state}, data) {
  commit('dashboard/load', true, {root: true});
  let seccion = secciones.filter(function(e){
    if(parseInt(e.titulo) === parseInt(state.seccionActual)) return e;
  });

  await $http_fds.get(sanitizarUrlSecciones(seccion[0].url.get, data))
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setAccion', 'editar');
      commit('setSeccionInfo', response.data.data);
      if (state.seccionActual === 1) {
        commit('setTipoDocumento', response.data.data.tipo_documento);
      }
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      commit('setAccion', 'crear');
      commit('resetSeccion');
    });
}

/**
 * Función para invocar la creación de la sección.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearSeccion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let seccion = secciones.filter(function(e){
    if(parseInt(e.titulo) === parseInt(state.seccionActual)) return e;
  });

  let data = state['selectedSeccion' + state.seccionActual];
  data.id_empresa = (data.id_empresa === null) ? state.id_empresa : data.id_empresa;

  if (seccion[0].url.post === undefined) {
    return true;
  }

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(sanitizarUrlSecciones(seccion[0].url.post), data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        if (state.seccionActual === 1) {
          state.selectedSeccion1.id_fds_producto = response.data.data.id;
        } else {
          commit('setAccion', 'editar');
          commit('setSeccionInfo', response.data.data);
        }
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error['selectedSeccion' + state.seccionActual] = error.errors;
        }
        reject();
      });
  });
}

/**
 * Función para invocar la edición de la sección.
 * @param commit
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarSeccion({commit, state}) {
  commit('dashboard/load', true, {root: true});
  let seccion = secciones.filter(function(e){
    if(parseInt(e.titulo) === parseInt(state.seccionActual)) return e;
  });

  if (seccion[0].url.post === undefined) {
    return true;
  }

  let data = state['selectedSeccion' + state.seccionActual];

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(sanitizarUrlSecciones(seccion[0].url.put, { id: data.id }), data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        state.error['selectedSeccion' + state.seccionActual] = error.errors;
        reject();
      });
  });
}

// Convertir TE en FDS
/**
 * Método para convertir tarjeta de emergencia en ficha de datos de seguridad.
 * @param commit
 * @param state
 * @param data
 * @returns {Promise<unknown>}
 */
export async function convertTe2Fds({commit, state}, data) {
  commit('dashboard/load', true, {root: true});

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/conversion/te/fds`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        reject();
      });
  });
}

// Funciones especificas componentes Sección 3
/**
 * Obtener componentes detalle.
 * @param commit
 * @param dispatch
 * @param state
 * @param id_fds_producto
 * @returns {Promise<void>}
 */
export async function getComponentesDetalle({commit, dispatch, state}, id_fds_producto) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;

  await $http_fds.get(`fds/producto/componentes/detalle/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setComponentesDetalle', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      commit('resetComponentesDetalle');
    });
}

/**
 * Crear componentes detalle.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearComponenteDetalle({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_fds_producto = state.selectedSeccion3.id_fds_producto;
  let data = state.selectedComponente;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/componentes/detalle`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedComponente');
        dispatch('getComponentesDetalle', id_fds_producto);
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
        reject();
      });
  });
}

/**
 * Editar componentes detalle.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarComponenteDetalle({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_fds_producto = state.selectedSeccion3.id_fds_producto;
  let id_componente_detalle = state.selectedComponente.id;
  let data = state.selectedComponente;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/componentes/detalle/${id_componente_detalle}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedComponente');
        dispatch('getComponentesDetalle', id_fds_producto);
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Eliminar componentes detalle.
 * @param commit
 * @param dispatch
 * @param state
 * @param data
 * @returns {Promise<void>}
 */
export async function borrarComponenteDetalle({commit, dispatch, state}, data) {
  commit('dashboard/load', true, {root: true});
  let id_fds_producto = state.selectedSeccion3.id_fds_producto;
  await $http_fds.delete(`fds/producto/componentes/detalle/${data.id_empresa}/${data.id_fds_producto}/${data.id}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      dispatch('getComponentesDetalle', id_fds_producto);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        html: error.message,
        showConfirmButton: true
      });
      if (error.errors !== undefined) {
        state.error = error.errors;
      }
    });
}

// Funciones especificas valores exposicion Sección 8
/**
 * Obtener valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<void>}
 */
export async function getValoresExposicion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;
  let id_fds_producto = state.selectedSeccion8.id_fds_producto;
  commit('resetSelectedValorExpo');

  await $http_fds.get(`fds/producto/controles_exposicion/detalle/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setValoresExposicion', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Obtener iconos epp.
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function getEppIconos({commit, state}) {
  commit('dashboard/load', true, {root: true});

  await $http_fds.get(`epps`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setElementosProteccion', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Obtener elementos de protección personal.
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function getElementosProteccion({commit, state}) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;
  let id_fds_producto = state.selectedSeccion8.id_fds_producto;
  commit('resetSelectedElementosProteccion');

  await $http_fds.get(`fds/producto/epp/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setSelectedElementosProteccion', response.data.data);
      commit('setAccionSelectedElementosProteccion', 'editar');
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Guardar elementos de protección personal.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function guardarElementosProteccion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedElementosProteccion;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = state.selectedSeccion8.id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/epp`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedElementosProteccion');
        dispatch('getElementosProteccion');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        reject();
      });
  });
}

/**
 * Editar elementos de protección personal.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarElementosProteccion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedElementosProteccion;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = state.selectedSeccion8.id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/epp`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedElementosProteccion');
        dispatch('getElementosProteccion');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        reject();
      });
  });
}

/**
 * Crear valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearValoresExposicion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedValorExpo;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = state.selectedSeccion8.id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/controles_exposicion/detalle`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedValorExpo');
        dispatch('getValoresExposicion');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Editar valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarValoresExposicion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_componente_detalle = state.selectedValorExpo.id;
  let data = state.selectedValorExpo;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/controles_exposicion/detalle/${id_componente_detalle}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedValorExpo');
        dispatch('getValoresExposicion');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Eliminar valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @param data
 * @returns {Promise<void>}
 */
export async function borrarValoresExposicion({commit, dispatch, state}, data) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.delete(`fds/producto/controles_exposicion/detalle/${data.id_empresa}/${data.id_fds_producto}/${data.id}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      dispatch('getValoresExposicion');
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        html: error.message,
        showConfirmButton: true
      });
      if (error.errors !== undefined) {
        state.error = error.errors;
      }
    });
}

// Funciones especificas valores exposicion Sección 8
/**
 * Obtener otros valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<void>}
 */
export async function getOtrosValoresExposicion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;
  let id_fds_producto = state.selectedSeccion8.id_fds_producto;
  commit('resetSelectedValorExpoOtros');

  await $http_fds.get(`fds/producto/controles_exposicion/otros/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setSelectedValorExpoOtros', response.data.data);
      commit('setAccionSelectedValorExpoOtros', 'editar');
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      commit('resetSelectedValorExpo');
      commit('setAccionSelectedValorExpoOtros', 'crear');
    });
}

/**
 * Crear otros valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearOtrosValoresExposicion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedValorExpoOtros;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = state.selectedSeccion8.id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/controles_exposicion/otros`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Editar otros valores de exposición.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarOtrosValoresExposicion({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_componente_detalle = state.selectedValorExpoOtros.id;
  let data = state.selectedValorExpoOtros;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/controles_exposicion/otros/${id_componente_detalle}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

// Funciones especificas carcinogenicidades Sección 11
/**
 * Obtener grupos de la IARC.
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function getIarcGrupos({state, commit}) {
  commit('dashboard/load', true, {root: true});
  await $http.get(`adm_general/listas/codigo-control/IA-9fb`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setIarcGrupos', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.errors,
        showConfirmButton: false,
        timer: 2000
      });
    })
}

/**
 * Obtener carcinogenicidades.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<void>}
 */
export async function getCarcinogenicidad({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;
  let id_fds_producto = state.selectedSeccion11.id_fds_producto;
  commit('resetSelectedCarcinogenicidad');

  await $http_fds.get(`fds/producto/informacion_toxicologica/carcinogenicidad/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setCarcinogenicidades', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Crear carcinogenicidad.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearCarcinogenicidad({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedCarcinogenicidad;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = state.selectedSeccion11.id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/informacion_toxicologica/carcinogenicidad`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedCarcinogenicidad');
        dispatch('getCarcinogenicidad');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Actualizar carcinogenicidad.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarCarcinogenicidad({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_componente_detalle = state.selectedCarcinogenicidad.id;
  let data = state.selectedCarcinogenicidad;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/informacion_toxicologica/carcinogenicidad/${id_componente_detalle}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedCarcinogenicidad');
        dispatch('getCarcinogenicidad');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Eliminar carcinogenicidad.
 * @param commit
 * @param dispatch
 * @param state
 * @param data
 * @returns {Promise<void>}
 */
export async function borrarCarcinogenicidad({commit, dispatch, state}, data) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.delete(`fds/producto/informacion_toxicologica/carcinogenicidad/${data.id_empresa}/${data.id_fds_producto}/${data.id}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      dispatch('getCarcinogenicidad');
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        html: error.message,
        showConfirmButton: true
      });
      if (error.errors !== undefined) {
        state.error = error.errors;
      }
    });
}

// Funciones especificas toxicidad Sección 11
/**
 * Obtener animales para toxicidades.
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function getAnimales({state, commit}) {
  commit('dashboard/load', true, {root: true});
  let codigo = (state.tipo_toxicidad === 'ecotoxicidad') ? 'ESPEC' : 'ANIM';
  await $http.get(`adm_general/listas/codigo-control/${codigo}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setAnimales', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.errors,
        showConfirmButton: false,
        timer: 2000
      });
    })
}

/**
 * Obtener vias de ingreso para toxicidades.
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function getViasIngreso({state, commit}) {
  commit('dashboard/load', true, {root: true});
  await $http.get(`adm_general/listas/codigo-control/vingtx`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setViasIngreso', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.errors,
        showConfirmButton: false,
        timer: 2000
      });
    })
}

/**
 * Obtener marcadores para toxicidades.
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function getMarcadores({state, commit}) {
  commit('dashboard/load', true, {root: true});
  let codigo = (state.tipo_toxicidad === 'ecotoxicidad') ? 'maretx' : 'marctx';
  await $http.get(`adm_general/listas/codigo-control/${codigo}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setMarcadores', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.errors,
        showConfirmButton: false,
        timer: 2000
      });
    })
}

/**
 * Obtener toxicidades.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<void>}
 */
export async function getToxicidades({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;
  let id_fds_producto = (state.tipo_toxicidad === 'toxicidad') ? state.selectedSeccion11.id_fds_producto : state.selectedSeccion12.id_fds_producto;
  commit('resetSelectedToxicidad');

  await $http_fds.get(`fds/producto/${state.tipo_toxicidad}/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setToxicidades', response.data.data);
    })
    .catch((error) => {
      commit('setToxicidades', []);
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Creación de toxicidad.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearToxicidad({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedToxicidad;
  data.id_empresa = state.id_empresa;
  let id_fds_producto = (state.tipo_toxicidad === 'toxicidad') ? state.selectedSeccion11.id_fds_producto : state.selectedSeccion12.id_fds_producto;
  data.id_fds_producto = id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/${state.tipo_toxicidad}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedToxicidad');
        dispatch('getToxicidades');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Editar toxicidad.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarToxicidad({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_componente_tox = state.selectedToxicidad.id;
  let data = state.selectedToxicidad;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/${state.tipo_toxicidad}/${id_componente_tox}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedToxicidad');
        dispatch('getToxicidades');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Eliminar toxicidad.
 * @param commit
 * @param dispatch
 * @param state
 * @param data
 * @returns {Promise<void>}
 */
export async function borrarToxicidad({commit, dispatch, state}, data) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.delete(`fds/producto/${state.tipo_toxicidad}/${data.id_empresa}/${data.id_fds_producto}/${data.id}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      dispatch('getToxicidades');
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        html: error.message,
        showConfirmButton: true
      });
      if (error.errors !== undefined) {
        state.error = error.errors;
      }
    });
}

// Componentes CAS
/**
 * Obtener componentes de cas.
 * @param commit
 * @param rootState
 * @param state
 * @param dispatch
 * @returns {Promise<void>}
 */
export async function obtenerComponentesCas({commit, rootState, state, dispatch}) {
  commit('dashboard/load', true, {root: true});

  let tipoCas = rootState.nuevocas.tiposCas.filter(tipo => tipo.lista === state.tipo_peligro)[0];

  let data = {
    cas_numbers: [],
    danger_id: tipoCas.id,
  }
  state.componentes_detalle.forEach((comp) => {
    data.cas_numbers.push(comp.cas);
  });
  commit('resetSelectedValorExpo');

  await $http.post(`cas/listar-componente-cas`, data)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setComponentesFds', response.data.components);
      if (state.tipo_peligro === 'TLV') {
        dispatch('formatearComponentesTlv');
      } else if (state.tipo_peligro === 'IARC') {
        dispatch('formatearComponentesIarc');
      }
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Formatear componentes de cas.
 * @param commit
 * @param rootState
 * @param state
 * @returns {Promise<void>}
 */
export async function formatearComponentesTlv({commit, rootState, state}) {
  state.items_sugerencias = [];
  if (state.componentesFds.length !== 0 && rootState.nuevocas.tiposCas.length !== 0) {

    state.componentesFds.forEach((componente) => {
      let acgih_stel_value = null;
      let acgih_stel_simbol_value = null;
      let acgih_stel_simbol_txt = null;
      let acgih_twa_value = null;
      let acgih_twa_simbol_value = null;
      let acgih_twa_simbol_txt = null;

      // Valor STEL
      if (componente.field_values['ACGIH STEL'] !== undefined) {
        let acgih_stel = componente.field_values['ACGIH STEL'];
        acgih_stel_value = acgih_stel.value;
      }

      // Simbolo STEL
      if (componente.field_values['ACGIH STEL UNIDADES'] !== undefined) {
        let acgih_stel_simbol = componente.field_values['ACGIH STEL UNIDADES'];
        acgih_stel_simbol_value = acgih_stel_simbol.value;
        acgih_stel_simbol_txt = `${acgih_stel_value} ${acgih_stel_simbol.list}`;
      }

      // Valor TWA
      if (componente.field_values['ACGIH TWA'] !== undefined) {
        let acgih_twa = componente.field_values['ACGIH TWA'];
        acgih_twa_value = acgih_twa.value;
      }

      // Simbolo TWA
      if (componente.field_values['ACGIH TWA UNIDADES'] !== undefined) {
        let acgih_twa_simbol = componente.field_values['ACGIH TWA UNIDADES'];
        acgih_twa_simbol_value = acgih_twa_simbol.value;
        acgih_twa_simbol_txt = `${acgih_twa_value} ${acgih_twa_simbol.list}`;
      }

      state.items_sugerencias.push({
        componente: componente.name,
        cas_number: componente.cas_number,
        acgih_stel: acgih_stel_value,
        acgih_stel_simbol: acgih_stel_simbol_value,
        acgih_stel_simbol_txt: acgih_stel_simbol_txt,
        acgih_twa: acgih_twa_value,
        acgih_twa_simbol: acgih_twa_simbol_value,
        acgih_twa_simbol_txt: acgih_twa_simbol_txt,
      });
    });
  }
}

/**
 * Formatear componentes de IARC.
 * @param commit
 * @param rootState
 * @param state
 * @returns {Promise<void>}
 */
export async function formatearComponentesIarc({commit, rootState, state}) {
  state.items_sugerencias = [];
  if (state.componentesFds.length !== 0 && rootState.nuevocas.tiposCas.length !== 0) {

    state.componentesFds.forEach((componente) => {
      let grupo_value = null;
      let grupo_text = null;

      // Grupo
      if (componente.field_values['Grupo'] !== undefined) {
        let grupo = componente.field_values['Grupo'];
        grupo_value = grupo.value;
        grupo_text = grupo.list;
      }

      state.items_sugerencias.push({
        componente: componente.name,
        cas_number: componente.cas_number,
        id_grupo: grupo_value,
        grupo: grupo_text
      });
    });
  }
}

/**
 * Agregar sugerencias de cas.
 * @param commit
 * @param state
 * @param dispatch
 * @param data
 * @returns {Promise<void>}
 */
export async function agregarSugerenciaCas({commit, state, dispatch}, data) {
  commit('prepareSugerenciaCas', data);
  if (state.tipo_peligro === 'TLV') {
    dispatch('crearValoresExposicion');
  } else if (state.tipo_peligro === 'IARC') {
    dispatch('crearCarcinogenicidad');
  }
}

/**
 * Obtener tipos de transporte.
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */
export async function getTiposTransporte({state, commit}) {
  commit('dashboard/load', true, {root: true});
  await $http.get(`adm_general/listas/codigo-control/TUN`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setTiposTransporte', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.errors,
        showConfirmButton: false,
        timer: 2000
      });
    })
}

/**
 * Obtener detalle de transportes.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<void>}
 */
export async function getTransportesDetalle({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_empresa = state.id_empresa;
  let id_fds_producto = state.selectedSeccion14.id_fds_producto;
  commit('resetSelectedTransporte');

  await $http_fds.get(`fds/producto/naciones_unidas/detalle/${id_empresa}/${id_fds_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setTransportesDetalle', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Crear detalle de transporte.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function crearTransporteDetalle({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let data = state.selectedTransporte;
  data.id_empresa = state.id_empresa;
  data.id_fds_producto = state.selectedSeccion14.id_fds_producto;

  return new Promise(async (resolve, reject) => {
    await $http_fds.post(`fds/producto/naciones_unidas/detalle`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedTransporte');
        dispatch('getTransportesDetalle');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Editar detalle de transporte.
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<unknown>}
 */
export async function actualizarTransporteDetalle({commit, dispatch, state}) {
  commit('dashboard/load', true, {root: true});
  let id_componente_detalle = state.selectedTransporte.id;
  let data = state.selectedTransporte;

  return new Promise(async (resolve, reject) => {
    await $http_fds.put(`fds/producto/naciones_unidas/detalle/${id_componente_detalle}`, data)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.title,
          text: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        commit('resetSelectedTransporte');
        dispatch('getTransportesDetalle');
        resolve();
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          html: error.message,
          showConfirmButton: true
        });
        if (error.errors !== undefined) {
          state.error = error.errors;
        }
        reject();
      });
  });
}

/**
 * Eliminar detalle de transporte.
 * @param commit
 * @param dispatch
 * @param state
 * @param data
 * @returns {Promise<void>}
 */
export async function borrarTransporteDetalle({commit, dispatch, state}, data) {
  commit('dashboard/load', true, {root: true});
  await $http_fds.delete(`fds/producto/naciones_unidas/detalle/${data.id_empresa}/${data.id_fds_producto}/${data.id}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.title,
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      dispatch('getTransportesDetalle');
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        html: error.message,
        showConfirmButton: true
      });
      if (error.errors !== undefined) {
        state.error = error.errors;
      }
    });
}


/**
 * Inactivar producto modulo fds.
 *
 * @param {*} payload
 */
export async function inactivateProductFdsTe({ commit },payload) {
  try {
    commit("dashboard/load", true, { root: true });
    const response = await $http_fds.put(`fds/producto-inactivar`, payload);
    this.$vue.$alertSuccess(response.data.message);
  } catch (error) {
    if (this.$vue.$alertErrorsCallback(error)) return;
    this.$vue.$alertError(error.message);
  } finally {
    commit("dashboard/load", false, { root: true });
  }
}
